// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_Internal_Effect from "../Specular.Internal.Effect/index.js";
import * as Specular_Internal_RIO from "../Specular.Internal.RIO/index.js";
import * as Specular_Profiling from "../Specular.Profiling/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Effect.monoidEffect(Data_Monoid.monoidUnit));
var measure = /* #__PURE__ */ Specular_Profiling.measure(Effect_Class.monadEffectEffect);
var join = /* #__PURE__ */ Control_Bind.join(Effect.bindEffect);
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(Effect.applyEffect);
var Builder = function (x) {
    return x;
};
var unBuilder = function (v) {
    return v;
};
var runBuilderWithUserEnv = function (userEnv) {
    return function (parent) {
        return function (v) {
            return function __do() {
                var actionsMutable = Specular_Internal_Effect.emptyDelayed();
                var env = {
                    parent: parent,
                    cleanup: actionsMutable,
                    userEnv: userEnv
                };
                var result = Specular_Internal_RIO.runRIO(env)(v)();
                var actions = Specular_Internal_Effect.unsafeFreezeDelayed(actionsMutable)();
                return new Data_Tuple.Tuple(result, Specular_Internal_Effect.sequenceEffects(actions));
            };
        };
    };
};
var runBuilder$prime = function (env, v) {
    return v(env);
};
var runBuilder = /* #__PURE__ */ runBuilderWithUserEnv(Data_Unit.unit);
var monadEffectBuilder = Specular_Internal_RIO.monadEffectRIO;
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(monadEffectBuilder);
var monadBuilder = Specular_Internal_RIO.monadRIO;
var monadDomBuilderBuilder = {
    liftBuilder: function (fn) {
        return fn;
    },
    liftBuilderWithRun: function (fn) {
        return Specular_Internal_RIO.rio(function (env) {
            return function () {
                return fn(env, function (env$prime, v) {
                    return v(env$prime);
                });
            };
        });
    },
    Monad0: function () {
        return monadBuilder;
    }
};
var mkBuilder$prime = function ($58) {
    return Builder(Specular_Internal_RIO.RIO($58));
};
var mkBuilder = function ($59) {
    return Builder(Specular_Internal_RIO.rio($59));
};
var monadCleanupBuilder = {
    onCleanup: function (action) {
        return mkBuilder(function (env) {
            return Specular_Internal_Effect.pushDelayed(env.cleanup)(action);
        });
    },
    Monad0: function () {
        return monadBuilder;
    }
};
var onCleanup = /* #__PURE__ */ Control_Monad_Cleanup.onCleanup(monadCleanupBuilder);
var local = function (fn) {
    return function (v) {
        return Specular_Internal_RIO.local(function (env) {
            return {
                cleanup: env.cleanup,
                parent: env.parent,
                userEnv: fn(env.userEnv)
            };
        })(v);
    };
};
var getParentNode = /* #__PURE__ */ Control_Monad_Reader_Class.asks(Specular_Internal_RIO.monadAskRIO)(function (v) {
    return v.parent;
});
var getEnv = /* #__PURE__ */ Control_Monad_Reader_Class.ask(Specular_Internal_RIO.monadAskRIO);
var functorBuilder = Specular_Internal_RIO.functorRIO;
var monadAskBuilder = {
    ask: /* #__PURE__ */ Data_Functor.map(functorBuilder)(function (v) {
        return v.userEnv;
    })(getEnv),
    Monad0: function () {
        return monadBuilder;
    }
};
var monadReaderBuilder = {
    local: local,
    MonadAsk0: function () {
        return monadAskBuilder;
    }
};
var bindBuilder = Specular_Internal_RIO.bindRIO;
var bind1 = /* #__PURE__ */ Control_Bind.bind(bindBuilder);
var discard2 = /* #__PURE__ */ discard(bindBuilder);
var applyBuilder = Specular_Internal_RIO.applyRIO;
var lift2 = /* #__PURE__ */ Control_Apply.lift2(applyBuilder);
var semigroupBuilder = function (dictSemigroup) {
    return {
        append: lift2(Data_Semigroup.append(dictSemigroup))
    };
};
var applicativeBuilder = Specular_Internal_RIO.applicativeRIO;
var pure1 = /* #__PURE__ */ Control_Applicative.pure(applicativeBuilder);
var $lazy_monadReplaceBuilder = /* #__PURE__ */ $runtime_lazy("monadReplaceBuilder", "Specular.Dom.Builder", function () {
    return {
        newSlot: bind1(getEnv)(function (env) {
            return bind1(liftEffect(Specular_Dom_Browser.createTextNode("")))(function (placeholderBefore) {
                return bind1(liftEffect(Specular_Dom_Browser.createTextNode("")))(function (placeholderAfter) {
                    return discard2(liftEffect(Specular_Dom_Browser.appendChild(placeholderBefore)(env.parent)))(function () {
                        return discard2(liftEffect(Specular_Dom_Browser.appendChild(placeholderAfter)(env.parent)))(function () {
                            return bind1(liftEffect(Effect_Ref["new"](mempty)))(function (cleanupRef) {
                                var replace = function (inner) {
                                    return measure("slot replace")(function __do() {
                                        measure("slot remove DOM")(Specular_Dom_Browser.removeAllBetween(placeholderBefore)(placeholderAfter))();
                                        var fragment = Specular_Dom_Browser.createDocumentFragment();
                                        var v = measure("slot init")(runBuilderWithUserEnv(env.userEnv)(fragment)(inner))();
                                        join(Effect_Ref.read(cleanupRef))();
                                        var m_parent = Specular_Dom_Browser.parentNode(placeholderAfter)();
                                        (function () {
                                            if (m_parent instanceof Data_Maybe.Just) {
                                                Specular_Dom_Browser.insertBefore(fragment)(placeholderAfter)(m_parent.value0)();
                                                return Effect_Ref.write(measure("slot cleanup")(function __do() {
                                                    v.value1();
                                                    return Effect_Ref.write(mempty)(cleanupRef)();
                                                }))(cleanupRef)();
                                            };
                                            if (m_parent instanceof Data_Maybe.Nothing) {
                                                return Effect_Ref.write(v.value1)(cleanupRef)();
                                            };
                                            throw new Error("Failed pattern match at Specular.Dom.Builder (line 113, column 9 - line 126, column 37): " + [ m_parent.constructor.name ]);
                                        })();
                                        return v.value0;
                                    });
                                };
                                var destroy = function __do() {
                                    Specular_Dom_Browser.removeAllBetween(placeholderBefore)(placeholderAfter)();
                                    Specular_Dom_Browser.removeNode(placeholderBefore)();
                                    Specular_Dom_Browser.removeNode(placeholderAfter)();
                                    return join(Effect_Ref.read(cleanupRef))();
                                };
                                var append = function __do() {
                                    var fragment = Specular_Dom_Browser.createDocumentFragment();
                                    var v = runBuilderWithUserEnv(env.userEnv)(fragment)(Control_Monad_Replace.newSlot($lazy_monadReplaceBuilder(0)))();
                                    Effect_Ref.modify_(function (v1) {
                                        return applySecond(v1)(v.value1);
                                    })(cleanupRef)();
                                    var m_parent = Specular_Dom_Browser.parentNode(placeholderAfter)();
                                    (function () {
                                        if (m_parent instanceof Data_Maybe.Just) {
                                            return Specular_Dom_Browser.insertBefore(fragment)(placeholderAfter)(m_parent.value0)();
                                        };
                                        if (m_parent instanceof Data_Maybe.Nothing) {
                                            return Data_Unit.unit;
                                        };
                                        throw new Error("Failed pattern match at Specular.Dom.Builder (line 145, column 9 - line 149, column 22): " + [ m_parent.constructor.name ]);
                                    })();
                                    return v.value0;
                                };
                                return discard2(onCleanup(join(Effect_Ref.read(cleanupRef))))(function () {
                                    return pure1(new Control_Monad_Replace.Slot(replace, destroy, append));
                                });
                            });
                        });
                    });
                });
            });
        }),
        Monad0: function () {
            return monadBuilder;
        },
        MonadCleanup1: function () {
            return monadCleanupBuilder;
        }
    };
});
var monadReplaceBuilder = /* #__PURE__ */ $lazy_monadReplaceBuilder(88);
var monoidBuilder = function (dictMonoid) {
    var semigroupBuilder1 = semigroupBuilder(dictMonoid.Semigroup0());
    return {
        mempty: pure1(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupBuilder1;
        }
    };
};
export {
    runBuilder,
    local,
    unBuilder,
    mkBuilder$prime,
    mkBuilder,
    runBuilder$prime,
    getParentNode,
    functorBuilder,
    applyBuilder,
    applicativeBuilder,
    bindBuilder,
    monadBuilder,
    monadEffectBuilder,
    monadCleanupBuilder,
    monadAskBuilder,
    monadReaderBuilder,
    monadReplaceBuilder,
    monadDomBuilderBuilder,
    semigroupBuilder,
    monoidBuilder
};
